import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrecastFigureOrderBucket } from 'src/app/shared/models/FigureOrderItem';
import { IPrecastRecord } from 'src/app/shared/models/i-precast-record.modal';
import { HttpService } from 'src/app/shared/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  projectInformation : IPrecastRecord;
  constructor(private httpService: HttpService) { }

  public fetchReportData(projectId: string): Observable<any> {
    const url = `precastreports/GetPreCastReport/${projectId}`;

    return this.httpService.get(url);
  }

  public updatePrecastReport(payload: any): Observable<any> {
    return this.httpService.post('precastreports/UpdateReport', payload);
  }

  public getGraphData(projectId: string): Observable<any> {
    const url = `precastreports/GetPreCastGraphData/${projectId}`;
    return this.httpService.get(url);
  }

  public getReviewAssign(projectId: string): Observable<any> {
    return this.httpService.get(`project/getprojectreiew/${projectId}`);
  }

  public updatePrecastWorksheets(
    projectID: string,
    isMetric: boolean,
    figureObject: {
      precastFigureSamples: {
        precastSampleID: string;
        curves: {
          precastWorksheetID: string;
          average: boolean;
          curve: { moistureContent: number; tr: number }[];
        }[];
      }[];
    },
  ): Observable<any> {
    return this.httpService.post('precastreports/UpdatePreCastWorksheets', {
      projectID,
      isMetric,
      figureObject,
    });
  }

  public orderPrecastFigures(
    figureOrdering: { [bucket: number]: PrecastFigureOrderBucket },
    projectId: string,
    reordered: boolean,
  ): Observable<any> {
    return this.httpService.post('precastreports/OrderPrecastFigures', {
      projectId,
      figureOrdering,
      reordered,
    });
  }

  public getPrecastFigureOrderings(projectID: string): Observable<any> {
    return this.httpService.get(`precastreports/GetPrecastFigureOrderings/${projectID}`);
  }

  public updateFigureProperty(
    projectID: string,
    figureNumber: number,
    maxX: number | null,
    maxY: number | null,
  ): Observable<any> {
    return this.httpService.post('precastreports/UpdateFigureProperty', {
      projectID,
      figureNumber,
      maxX,
      maxY,
    });
  }

  public updateAllFiguresScales(
    projectID: string,
    maxX: number | null,
    maxY: number | null,
  ): Observable<void> {
    return this.httpService.post('precastreports/UpdateAllFiguresScales', {
      projectID,
      maxX,
      maxY,
    }, {
      responseType: 'text',
    });
  }

  public createPreCastGraphs(isMetric: boolean, projectId: string, figureNumber: number): Observable<Blob> {
    return this.httpService.postBlob('precastreports/CreatePreCastGraphs', {
      isMetric, projectId, figureNumber,
    });
  }

  public createPrecastReportFromData(payload: any): Observable<Blob> {
    return this.httpService.postBlob('precastreports/CreatePrecastReportFromData', payload);
  }

  public createPrecastReportPDFFromData(payload: any): Observable<Blob> {
    return this.httpService.postBlob('precastreports/CreatePrecastReportPDFFromData', payload);
  }
}
